import React, { FC } from "react";
import { ThemeProvider } from "@emotion/react";
import { Provider } from "react-redux";
import GlobalStore, { AppStore } from "../../state-management/store";
import Theme from "../../theme";
import AppMedia from "../../theme/utils/AppMedia";
import { GTMProvider } from "@elgorditosalsero/react-gtm-hook";

const { MediaContextProvider } = AppMedia;

export function ProvidersFactoryFromStore(store: AppStore): FC {
  const providers: FC = ({ children }) => {
    const gtmParams = {
      id: "GTM-5T2S9J",
    };

    return (
      <GTMProvider state={gtmParams}>
        <ThemeProvider theme={Theme.CE_THEME}>
          <MediaContextProvider>
            <Provider store={store}>{children}</Provider>
          </MediaContextProvider>
        </ThemeProvider>
      </GTMProvider>
    );
  };

  return providers;
}

const Providers: FC = ProvidersFactoryFromStore(GlobalStore);

export default Providers;
